import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActiveSubject = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 41,
	height: 40,
	viewBox: "0 0 41 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Frame 186",
		children: [/* @__PURE__ */ _jsx("rect", {
			x: .599609,
			width: 40,
			height: 40,
			rx: 2.75862,
			fill: "#CAE6D6"
		}), /* @__PURE__ */ _jsxs("g", {
			id: "person_edit",
			children: [/* @__PURE__ */ _jsx("mask", {
				id: "mask0_119_12934",
				style: { maskType: "alpha" },
				maskUnits: "userSpaceOnUse",
				x: 11,
				y: 10,
				width: 20,
				height: 20,
				children: /* @__PURE__ */ _jsx("rect", {
					id: "Bounding box",
					x: 11,
					y: 10,
					width: 20,
					height: 20,
					fill: "#D9D9D9"
				})
			}), /* @__PURE__ */ _jsx("g", {
				mask: "url(#mask0_119_12934)",
				children: /* @__PURE__ */ _jsx("path", {
					id: "person_edit_2",
					d: "M22.6663 27.5V24.9375L27.2705 20.3542C27.3955 20.2292 27.5344 20.1389 27.6872 20.0833C27.84 20.0278 27.9927 20 28.1455 20C28.3122 20 28.4719 20.0313 28.6247 20.0938C28.7775 20.1563 28.9163 20.25 29.0413 20.375L29.8122 21.1458C29.9233 21.2708 30.0101 21.4097 30.0726 21.5625C30.1351 21.7153 30.1663 21.8681 30.1663 22.0208C30.1663 22.1736 30.1386 22.3299 30.083 22.4896C30.0275 22.6493 29.9372 22.7917 29.8122 22.9167L25.2288 27.5H22.6663ZM14.333 26.6667V24.3333C14.333 23.8611 14.4545 23.4271 14.6976 23.0313C14.9406 22.6354 15.2636 22.3333 15.6663 22.125C16.5275 21.6945 17.4025 21.3715 18.2913 21.1563C19.1802 20.941 20.083 20.8333 20.9997 20.8333C21.5136 20.8333 22.0205 20.8646 22.5205 20.9271C23.0205 20.9896 23.5205 21.0903 24.0205 21.2292L20.9997 24.25V26.6667H14.333ZM28.1455 22.8333L28.9163 22.0208L28.1455 21.25L27.3538 22.0417L28.1455 22.8333ZM20.9997 20C20.083 20 19.2983 19.6736 18.6455 19.0208C17.9927 18.3681 17.6663 17.5833 17.6663 16.6667C17.6663 15.75 17.9927 14.9653 18.6455 14.3125C19.2983 13.6597 20.083 13.3333 20.9997 13.3333C21.9163 13.3333 22.7011 13.6597 23.3538 14.3125C24.0066 14.9653 24.333 15.75 24.333 16.6667C24.333 17.5833 24.0066 18.3681 23.3538 19.0208C22.7011 19.6736 21.9163 20 20.9997 20Z",
					fill: "#004A42"
				})
			})]
		})]
	})
});
export default SvgActiveSubject;
